import i18n from '../../i18n';

const locale = i18n.locale;
const messages = i18n.messages;

export default messages[locale];



/** WEBPACK FOOTER **
 ** ./src/helpers/i18n/index.js
 **/